module.exports = __webpack_public_path__ + "static/img/one.0122ee8c.png";